import axios from "axios";
import { getAuthHeader } from "../utils";

const baseUrl = (window.RUNTIME_CONFIG?.API_BASE_URL ?? "");

const resolveError = (error) => {
  const message =
    error?.response?.data?.error?.message ||
    error?.response?.data?.error ||
    error?.message ||
    "Request failed";
  return new Error(typeof message === "string" ? message : "Request failed");
};

export const apiGet = async (path, config = {}) => {
  try {
    const res = await axios.get(`${baseUrl}${path}`, { ...getAuthHeader(), ...config });
    return res.data;
  } catch (error) {
    throw resolveError(error);
  }
};

export const apiPost = async (path, body = {}, config = {}) => {
  try {
    const res = await axios.post(`${baseUrl}${path}`, body, { ...getAuthHeader(), ...config });
    return res.data;
  } catch (error) {
    throw resolveError(error);
  }
};

export const apiPut = async (path, body = {}, config = {}) => {
  try {
    const res = await axios.put(`${baseUrl}${path}`, body, { ...getAuthHeader(), ...config });
    return res.data;
  } catch (error) {
    throw resolveError(error);
  }
};

export const apiPatch = async (path, body = {}, config = {}) => {
  try {
    const res = await axios.patch(`${baseUrl}${path}`, body, { ...getAuthHeader(), ...config });
    return res.data;
  } catch (error) {
    throw resolveError(error);
  }
};
